import React from 'react';
import './styles/global.css';
import './styles/Chatbot.css';
import './styles/Sections.css';
import Navbar from './components/Navbar';
import { Hero, Solucoes, Sobre, Contato, Footer } from './components/Sections';
import Chatbot from './components/Chatbot';

export default function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Solucoes />
        <Sobre />
        <Contato />
      </main>
      <Footer />
      <Chatbot />
    </>
  );
}
